<template>
    <div class="color-container" >
        <VTooltip theme="color-picker" :triggers="['click', 'focus']" auto-hide  :placement="'bottom'" @hide="closeMenu">
            <div class="open-button">
                <div 
                
                @click="open ? closeMenu() :openColorSelector()"
                >
                    <slot>
                        <div class="color main" :style="{backgroundColor: selectedColor ? selectedColor : '#000'}">

                        </div>
                    </slot>
                
                </div>
            </div>
            <template #popper>
                                            
                <div  class="picker-container" @click.stop.prevent >
                    <div class="tab-selector">
                        <span @click="tabIndex = 0">
                            <svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.8" d="M17 31L3 17L17 3" stroke="white" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                        <span @click="tabIndex = 1">
                            <svg width="20" height="34" viewBox="0 0 20 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.8" d="M3 3L17 17L3 31" stroke="white" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div>
                    <div class="color-wrapper" v-if="tabIndex==0">
                        <div 
                        class="color"
                        v-for="(color, index) in colorList"
                        :key="index"
                        @click="setColor(color)"
                        :class="{selected: color == selectedColor}"
                        :style="{backgroundColor: color}"
                        >
                        </div>
                    </div>
                    <div class="secondary-wrapper" v-if="tabIndex==1 && secondaryColorList && secondaryColorList.length > 0">
                        <div 
                            class="color"
                            v-for="(color, index) in secondaryColorList"
                            :key="index"
                            @click="setColor(color)"
                            :class="{selected: color == selectedColor}"
                            :style="{backgroundColor: color}"
                        >
                        </div>
                    </div>
                    <div class="hex-input">
                        <span>
                            hex:
                        </span>
                        <input type="text" maxlength="9" v-model.lazy="selectedColor" placeholder="#000000">
                    </div>
                </div>
            </template>
        </VTooltip>
    </div>
</template>

<script>
export default {

    data() {
        return {
            selectedColor: '',
            colorList: [
                "#1E1E1E",
                "#7143FF",
                "#F3A800",
                "#FFB612",
                "#179B74",
                "#35C4B5",
                "#EB5E35",
                "#FF3767",
                "#CAD2FF"
            ],
            secondaryColorList: [
                "#1E1E1E",
                "#FFFFFF",
                "#CEFFE7",
                "#7AE9BB",
                "#FF3767",
                "#FFF5CD"
            ],
            open: false,
            allowClose: false,
            tabIndex: 0
        }
    },
    mounted(){
        if(this.originalColor){
            this.selectedColor = this.originalColor
        }
    },
    props:{
        originalColor: {
            type: String,
            default: ''
        }
    },
    watch: {
        selectedColor() {
            if (!this.selectedColor.startsWith('#')) {
                this.selectedColor = '#' + this.selectedColor
            }
            this.$emit('selectColor', this.selectedColor)
        }
    },
    methods: {
        openColorSelector(){
            this.open = true;
        
            this.$store.state.tiptapTooltipOpen = true
            // this.$nextTick(() => {
            //     setTimeout(() => {
            //         this.allowClose = true
            //     },100)
            // })
        },
        closeMenu() {
            this.open = false
            this.$store.state.tiptapTooltipOpen = false
        },
        setColor(color) {
            if (color == this.selectedColor) {
                this.selectedColor = ''
            } 
            else {
                this.selectedColor = color
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.secondary-wrapper, .color-wrapper{
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}
.picker-container{
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 6px;
    max-width: 8rem;
    padding: 5px;
    gap: 10px;
    box-shadow: 0px 2px 4px 0px #0000004d;
}
.color-container{
    position: relative;
}
.icon{

}
.color{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid white;
    cursor: pointer;
    outline: 1px solid rgb(192, 192, 192);
    &:hover{
        outline: 1px solid rgb(3, 15, 139);
    }
    &.selected{
        outline: 1px solid rgb(3, 15, 139);
    }
    &.main{
        width: 16px;
        height: 16px;
    }
}
.hex-input{
    display: flex;
    align-items: center;
    gap: 5px;
    color: #333;
    input{
        border-radius: 6px;
        max-width: 80px;
        border: 2px solid rgb(156, 156, 156);
        padding: 5px 10px;
    }
}
.tab-selector{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    svg{
        height: 15px;
        cursor: pointer;
        path{
            stroke: #000;
        }
    }
}
</style>
<style lang="scss">
.v-popper--theme-color-picker .v-popper__inner{
    box-shadow: 0px 2px 4px 0px #0000004d;
}

.v-popper--theme-color-picker .v-popper__arrow-outer {
  border-color: #d9d9d9;
}
.v-popper--theme-color-picker .v-popper__arrow-inner {
  visibility: visible;
  border-color: #ffffff;
}
</style>